import api from "../../index";

export const GetVolumeReportSummaryApi = (params) =>
  api.get(`Sales/volume-report-summary?${params}`);

export const GetVolumeReportTrendApi = (params) =>
  api.get(`Sales/volume-report-trend?${params}`);

export const GetVolumeReportTopSymbolsApi = (params) =>
  api.get(`Sales/volume-report-top-symbols?${params}`);

export const GetOfficeGoalsReportApi = (params) =>
  api.get(`Sales/office-goals-report?${params}`);

export const GetTeamGoalsReportApi = (params) =>
  api.get(`Sales/team-goals-report?${params}`);

export const GetFtdReportApi = (params) =>
  api.get(`Sales/ftd-report?${params}`);
